var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "left_tree" },
        [
          _c(
            "a-spin",
            {
              staticStyle: { height: "100%" },
              attrs: { spinning: _vm.treeSpin },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { margin: "0 3px 10px 0" },
                      on: { click: _vm.add },
                    },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { margin: "0 3px 10px 0" },
                      on: { click: _vm.edit },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { margin: "0 3px 10px 0" },
                      on: { click: _vm.del },
                    },
                    [_vm._v("删除")]
                  ),
                ],
                1
              ),
              _c(
                "a-tree",
                {
                  attrs: {
                    "show-icon": true,
                    checkStrictly: true,
                    defaultExpandAll: false,
                    defaultExpandParent: true,
                    expandedKeys: _vm.defaultExpandedKeys,
                    "tree-data": _vm.deptList,
                    selectedKeys: _vm.selectedKeys,
                    replaceFields: {
                      children: "children",
                      title: "speechTypeName",
                      key: "speechTypeId",
                      value: "speechTypeId",
                    },
                  },
                  on: {
                    "update:expandedKeys": function ($event) {
                      _vm.defaultExpandedKeys = $event
                    },
                    "update:expanded-keys": function ($event) {
                      _vm.defaultExpandedKeys = $event
                    },
                    select: _vm.onSelect,
                    check: _vm.onCheck,
                  },
                },
                [
                  _c("a-icon", {
                    staticStyle: { color: "#2fcfeb" },
                    attrs: { slot: "dealer", type: "team" },
                    slot: "dealer",
                  }),
                  _c("a-icon", {
                    staticStyle: { color: "#52c41a" },
                    attrs: { slot: "region", type: "cluster" },
                    slot: "region",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right_table" },
        [
          _c("x-grid", {
            ref: "grid",
            attrs: {
              id: "formList",
              rowId: _vm.rowId,
              "pager-config": _vm.pagerConfig,
              "form-config": _vm.formConfig,
              url: _vm.url,
              columns: _vm.columns,
              "other-params": {
                speechTypeId: _vm.speechTypeId,
              },
              "checkbox-config": _vm.checkboxConfig,
              "toolbar-config": _vm.toolbarConfig,
              "print-config": _vm.printConfig,
              "export-config": _vm.exportConfig,
              cellClick: _vm.chooseRow,
              cellDbClick: _vm.updateRow,
            },
            on: {
              "toolbar-addData": _vm.addRow,
              "toolbar-delData": _vm.delRow,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: _vm.toolbarConfig.templatelSlots,
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "formModal",
        { attrs: { title: "常用话术", visible: _vm.editModalVisible } },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "客户分组",
            closable: true,
            footer: null,
            maskClosable: false,
            visible: _vm.editQuestion,
            width: 600,
          },
          on: {
            cancel: function ($event) {
              return _vm.closeQuestion()
            },
          },
        },
        [
          _vm.editQuestion
            ? _c("speech", {
                ref: "editQuestion",
                attrs: { rowId: _vm.editQuestionId, parentId: _vm.parentId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeQuestion()
                  },
                  saved: function ($event) {
                    return _vm.closeQuestion(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }